//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators';
import ValidationMixin from '../../../../common/form/mixins/ValidationMixin';

export default {
  name: 'PreferredUnits',
  mixins: [ValidationMixin],
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    updating: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    console.log(this.value);
  },
  data: function data() {
    return {
      options: [
        { value: null, text: 'Preferred Units' },
        { value: true, text: 'Metric' },
        { value: false, text: 'Imperial' },
      ],
    };
  },
  validations() {
    if (this.required) {
      return {
        value: {
          required,
        },
      };
    }
    return {};
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.$v.value.required) {
        errors.push('Preferred units is required');
      }
      return errors;
    },
  },
};
